import layout from "@/layout";

const orderBillRouter = {
    path: "/orderbill",
    name: "orderBill",
    redirect: {
        name: "orderbillList"
    },
    meta: {
        title: "订单发票"
    },
    component: layout,
    children: [
        // 采购订单列表
        {
            path: "list",
            name: "orderbillList",
            component: () => import("@/view/orderBill/orderbillList"),
            meta: {
                title: "采购订单发票"
            }
        },
        // 采购订单详情
        {
            path: "detail",
            name: "orderbillDetail",
            component: () => import("@/view/orderBill/orderbillDetail"),
            meta: {
                title: "采购单详情"
            }
        }
    ]
};

export default orderBillRouter;



// WEBPACK FOOTER //
// ./src/router/modules/orderBillRouter.js